import 'twin.macro';
import 'styled-components/macro';
import { useRouteMatch } from 'react-router';
import { Route, Switch } from 'react-router-dom';

import NotificationsContainer from 'play/molecules/notifications-container/NotificationsContainer';

import { Mode } from '../types/graphql';
import CompletionScreenContainer from './pages/completion/CompletionScreenContainer';
import { LearnEnvironment } from './pages/learn-environment/LearnEnvironment';
import { NotesContainer } from './pages/notes/NotesContainer';
import RecapContainer from './pages/recap/Recap';
import SplashScreenContainer from './pages/splash-screen/SplashScreenContainer';

export default function PlayApp() {
  return (
    <>
      <PlayRouter />
      <NotificationsContainer />
    </>
  );
}

const PlayRouter = () => {
  return (
    <Switch>
      <Route path="/embed/:teamSlug/tracks/:trackSlug" render={() => <LearnEnvironmentRouter mode={Mode.Embed} />} />
      <Route path="/embed/:teamSlug/:trackSlug" exact render={() => <LearnEnvironmentRouter mode={Mode.Embed} />} />
      <Route path="/embedv2/:teamSlug/tracks/:trackSlug" render={() => <LearnEnvironmentRouter mode={Mode.Embed} />} />
      <Route path="/:teamSlug/invite/:inviteID/tracks/:trackSlug" component={LearnEnvironmentRouter} />
      <Route path="/:teamSlug/tracks/:trackSlug" component={LearnEnvironmentRouter} />
    </Switch>
  );
};

interface LearnEnvironmentRouterProps {
  mode?: Mode;
}

const LearnEnvironmentRouter = ({ mode = Mode.Platform }: LearnEnvironmentRouterProps) => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route
        exact
        path={`${path}/challenges/:challengeSlug/notes`}
        render={({
          match: {
            params: { teamSlug, trackSlug, challengeSlug, inviteID },
          },
        }) => (
          <NotesContainer
            mode={mode}
            teamSlug={teamSlug}
            trackSlug={trackSlug}
            challengeSlug={challengeSlug}
            inviteID={inviteID}
          />
        )}
      />
      <Route
        exact
        path={`${path}/challenges/:challengeSlug/assignment`}
        render={({
          match: {
            params: { teamSlug, trackSlug, challengeSlug, inviteID },
          },
        }) => (
          <LearnEnvironment
            mode={mode}
            teamSlug={teamSlug}
            trackSlug={trackSlug}
            challengeSlug={challengeSlug}
            inviteID={inviteID}
          />
        )}
      />
      <Route
        path={`${path}/recap`}
        render={({
          match: {
            params: { teamSlug, trackSlug, inviteID },
          },
        }) => <RecapContainer mode={mode} teamSlug={teamSlug} trackSlug={trackSlug} inviteID={inviteID} />}
      />
      <Route
        path={`${path}/completion`}
        render={({
          match: {
            params: { teamSlug, trackSlug, inviteID },
          },
        }) => <CompletionScreenContainer mode={mode} teamSlug={teamSlug} trackSlug={trackSlug} inviteID={inviteID} />}
      />
      <Route
        render={({
          match: {
            params: { teamSlug, trackSlug, inviteID },
          },
        }) => <SplashScreenContainer mode={mode} teamSlug={teamSlug} trackSlug={trackSlug} inviteID={inviteID} />}
      />
    </Switch>
  );
};
